module.exports = __webpack_public_path__ + "static/img/reward-bg.51c8a23a.png";